import setFieldValue from "@bevco/Store/Handlers/RfqRequestQuote/SetFieldValue";
import { CustomActions, CustomState } from "@bevco/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
    validateFieldBy,
} from "@bevco/Widgets/RfqRequestQuote/FormBaseComponent";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const styles = {
    ...requestQuoteStyles.textFields,
};

const mapStateToProps = (state: CustomState) => ({
    company: state?.customRequestQuoteForm?.fieldValues?.company,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const CompanyWidget: React.FC<Props> = ({ fields: widgetFields, company, setFieldValue: widgetSetFieldValue }) => {
    const { label, hintText, isRequired } = widgetFields;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, company, "company", () =>
        validateFieldBy(isRequired, label, company, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "company", value: event.target.value });
    };

    return (
        <TextField
            {...styles}
            label={label}
            required={isRequired}
            placeholder={hintText}
            value={company || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CompanyWidget),
    definition: {
        group: "Request a Quote Form" as any,
        icon: "FormField",
        fieldDefinitions: [
            getRfqFormLabelBuilt("Company"),
            getRfqFormHintTextBuilt("Enter Company"),
            getRfqFormCheckboxBuilt(),
        ],
    },
};

export default widgetModule;
